module.exports = __webpack_public_path__ + "img/woman-otzS.48d26176.svg";